/**
 * SagoMax — toglie dal carrello gli «Imballo in tubo» rimasti senza il loro prodotto.
 *
 * Il personalizzatore aggiunge un tubo per ogni riga venduta al m² (poster, striscioni,
 * tappeti vinilici): è il collo che il corriere fattura. Se il cliente toglie il
 * prodotto, il tubo resterebbe lì a pesare sulla spedizione. Il carrello (Liquid, in
 * `snippets/cart-products.liquid`) sa quali tubi sono orfani e li elenca qui; questo
 * modulo li rimuove e ricarica, così il totale non mente mai.
 */
class SagomaxTubiOrfani extends HTMLElement {
  static inCorso = false;

  async connectedCallback() {
    const keys = (this.dataset.keys || '').split(',').filter(Boolean);
    if (keys.length === 0 || SagomaxTubiOrfani.inCorso) return;
    SagomaxTubiOrfani.inCorso = true;
    const updates = {};
    keys.forEach((k) => {
      updates[k] = 0;
    });
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (res.ok) window.location.reload();
    } catch (err) {
      console.warn('[sagomax-tubi] rimozione tubo orfano non riuscita:', err);
    } finally {
      SagomaxTubiOrfani.inCorso = false;
    }
  }
}

if (!customElements.get('sagomax-tubi-orfani')) {
  customElements.define('sagomax-tubi-orfani', SagomaxTubiOrfani);
}
